import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Section = styled.section<{
    $background?: COLORS,
    $top: number,
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: ${({ $background = COLORS.BgMain }) => $background};
    height: auto;

    position: relative;
    width: 100%;
    border-radius: 64px 64px 0 0;
    top: ${({ $top }) => $top}px;
    
    &:not(:last-child) {
        padding: 136px 0 116px;
    
        @media (max-width: ${wideBreakpoints.sDesktop}) {
            padding: 160px 0 100px;
        }
    
        @media (max-width: ${wideBreakpoints.laptop}) {
            padding: 112px 0 80px;
        }
    
        @media (max-width: ${wideBreakpoints.mobile}) {
            padding: 106px 0 52px;
            border-radius: 48px 48px 0 0;
        }
    }
`;

export const MessagesContainer = styled(FullWidthListContainer)`
    width: 924px;
    margin: 0 auto;
    margin-bottom: 116px;
    gap: 60px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-bottom: 100px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: 80px;
        width: 616px;
        gap: 40px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 328px;
        margin-bottom: 52px;
    }
`;

export const Image = styled(LazyLoadImage)`
    width: 100%;
    height: auto;
`;
